var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeDialTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 442.6 221.3",
    style: {
      enableBackground: "new 0 0 442.6 221.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.6,221.3c0-59.1-23-114.7-64.8-156.5S280.4,0,221.3,0S106.6,23,64.8,64.8S0,162.2,0,221.3 M15.1,221.3 c0.8-22.6,5.3-51.8,12.8-72l22.7,9.4c3.8,1.6,8.2-0.2,9.8-4.1c1.6-3.8-0.2-8.2-4.1-9.8l-22.7-9.4c9.2-20.1,21.7-38.5,36.6-54.6 l17.3,17.3c2.9,2.9,7.7,2.9,10.6,0c2.9-2.9,2.9-7.7,0-10.6L80.9,70.3c16-14.9,34.4-27.3,54.6-36.6l9.4,22.7c1.6,3.8,6,5.6,9.8,4.1 c3.8-1.6,5.6-6,4.1-9.8L149.3,28c20.2-7.5,41.9-12,64.5-12.8v6.6c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5v-6.6 c22.6,0.8,44.3,5.3,64.5,12.8l-9.4,22.7c-0.4,0.9-0.6,1.9-0.6,2.9c0,2.9,1.7,5.7,4.6,6.9c3.8,1.6,8.2-0.2,9.8-4.1l9.4-22.7 c20.1,9.3,38.5,21.7,54.6,36.6l-17.3,17.3c-1.5,1.5-2.2,3.4-2.2,5.3s0.7,3.8,2.2,5.3c2.9,2.9,7.7,2.9,10.6,0l17.3-17.3 c14.9,16,27.3,34.4,36.6,54.6l-22.7,9.4c-2.9,1.2-4.6,4-4.6,6.9c0,1,0.2,1.9,0.6,2.9c1.6,3.8,6,5.6,9.8,4.1l22.7-9.4 c7.5,20.2,12,49.4,12.8,72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeDialTop);
export default __webpack_public_path__ + "static/media/gauge_dial-top.b249e90d413d99894f2783c98737de67.svg";
export { ForwardRef as ReactComponent };